"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { theme, pxToEm, replacePXinStringWithEM, themeStyleHelper } from '../../../../utils/styles/index';

/* ++++++++++ --------------- EXPORT : TABLE : ROW : STYLES --------------- ++++++++++ */

var _default = {
  row: {
    // see table_styles for more (variants can alter styles)	
    // ----- states ----- //
    '&.processing-true': {
      '& td': {
        cursor: 'default',
        pointerEvents: 'none'
      }
    },
    '&.disabled-true': {
      cursor: 'default',
      pointerEvents: 'none',
      '& td': {
        backgroundColor: '#f1f1f1 !important',
        opacity: '.5'
      }
    },
    '&.clickable-true': {
      cursor: 'pointer'
    },
    // ----- align ----- //
    '&.align-left': {
      '& td, th': {
        textAlign: 'left'
      }
    },
    '&.align-center': {
      '& td, th': {
        textAlign: 'center'
      }
    },
    '&.align-right': {
      '& td, th': {
        textAlign: 'right'
      }
    }
  }
};
exports.default = _default;